export default function SortElement(params) {
    const arrowUp = `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12 3.25L6 9.235h4.5V19.75h3V9.235H18L12 3.25z" fill="#7D8A96"/>
                    </svg>`;

    const sort = document.createElement('div');
    sort.classList.add('w5-header-sort', 'w5-header-sort--hidden');
    sort.innerHTML = arrowUp;
    return sort;
}
